import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import SupportChat from "./SupportChat";
import "./WebsiteSupportWidget.css";

const WEBSITE_PATHS = new Set([
  "/",
  "/services",
  "/ecommerce",
  "/about",
  "/contact",
  "/privacy",
  "/thank-you",
]);

const WebsiteSupportWidget = () => {
  const location = useLocation();
  const { user } = useAuth();
  const isClient = String(user?.Role || "").toLowerCase() === "client";
  const isWebsitePage = WEBSITE_PATHS.has(location.pathname) || isClient;
  const hasTicketLink =
    new URLSearchParams(location.search).has("ticket") ||
    Boolean(window.tooraPendingGuestTicket);
  const [isOpen, setIsOpen] = useState(hasTicketLink);
  const [unreadCount, setUnreadCount] = useState(0);

  useEffect(() => {
    if (hasTicketLink) setIsOpen(true);
  }, [hasTicketLink]);

  useEffect(() => {
    const openSupportChat = () => setIsOpen(true);
    window.addEventListener("toora:open-support-chat", openSupportChat);
    return () =>
      window.removeEventListener("toora:open-support-chat", openSupportChat);
  }, []);

  if (!isWebsitePage) return null;

  return (
    <div className="website-support-widget">
      <div
        className={`website-support-panel ${isOpen ? "is-open" : ""}`}
        aria-hidden={!isOpen}
      >
        <SupportChat
          publicMode
          popupMode
          isWidgetOpen={isOpen}
          onUnreadCount={setUnreadCount}
          onClose={() => setIsOpen(false)}
        />
      </div>
      <button
        type="button"
        className={`website-support-launcher ${isOpen ? "is-open" : ""}`}
        aria-label={isOpen ? "Close Toora Flex chat" : "Open Toora Flex chat"}
        aria-expanded={isOpen}
        onClick={() => {
          setIsOpen((open) => !open);
          if (!isOpen) setUnreadCount(0);
        }}
      >
        <i className={`fas ${isOpen ? "fa-times" : "fa-comments"}`} aria-hidden="true" />
        {!isOpen && unreadCount > 0 && (
          <span className="website-support-unread" aria-label={`${unreadCount} new messages`}>
            {unreadCount > 9 ? "9+" : unreadCount}
          </span>
        )}
      </button>
    </div>
  );
};

export default WebsiteSupportWidget;
